import { Link } from "@tanstack/react-router";
import {
  useTheme,
  THEMES,
  DARK_BG,
  DARK_TEXT,
  LIGHT_BG,
  LIGHT_TEXT,
} from "../state/themeState.js";
import { BrandLogo } from "./BrandLogo.js";
import { NavMenu } from "./NavMenu.js";
import DoorOpen from "./common/Icons.js";
import styles from "../styles/components/TopBarMobile.module.css";

export function TopBarMobile() {
  const { themeIndex, hoveredThemeIndex, isDark } = useTheme();
  const accentColor =
    THEMES[hoveredThemeIndex ?? themeIndex]?.[isDark ? "dark" : "light"]
      .primary;
  function openRooms() {
    window.dispatchEvent(new CustomEvent("open-rooms-panel"));
  }

  return (
    <header className={styles.bar}>
      <div className={styles.breadcrumb}>
        <Link to="/" className={styles.logoLink}>
          <BrandLogo
            accentColor={accentColor}
            textColor={isDark ? DARK_TEXT : LIGHT_TEXT}
            backgroundColor={isDark ? DARK_BG : LIGHT_BG}
          />
        </Link>
        <button
          type="button"
          className={styles.roomBtn}
          onClick={openRooms}
          aria-label="Open rooms"
        >
          <DoorOpen width={18} height={18} color="var(--color-primary)" />
        </button>
      </div>
      <NavMenu />
    </header>
  );
}
